import React from 'react';
import DataTable from 'components/data-table';
import {RowItemDanhSachDoanDongNguoi} from 'modules/giai-quyet-don/datatable/rowItem';
import {header} from "constants/table";

class DanhSachDoanDongNguoi extends React.Component {
  render() {
    return (
      <div className="items-form wrap-block">
        <div className="title">
          <div className="rows">
            <div className="col-12">
              <h3>Danh sách đoàn</h3>
            </div>
          </div>
        </div>
        <div className="items-form white-table">
          <div className="rows mb15">
            <div className="col-12">
              <DataTable
              header = {header.detailReception.groupMember}
              dataList = {this.props.listDoanDiCung}
              hidePagination={true}
              hideExport={true}>
                <RowItemDanhSachDoanDongNguoi/>
              </DataTable>
            </div>
          </div>
          <div className="row pl20 pr20 mb20 pt5">
            <div className="line-border"></div>
          </div>
        </div>
      </div>
    );
  }
}

DanhSachDoanDongNguoi.defaultProps = {
  listDoanDiCung: []
}

export default DanhSachDoanDongNguoi;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/DanhSachDoanDongNguoi.jsx